import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";
import DropWrapper from "./component/DropWrapper";
import TaskItem from "./component/TaskItem";
import { clear_auth, set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import {Checkbox, Modal, Select, Upload} from "antd";
import CKEditor from "react-ckeditor-component";
import { toast } from "react-toastify";
import myImage from '../../assets/images/Mask_group.png';
import '../styling.css'
import SearchIcon from "../../assets/icons/search.svg";
import RefreshIcon from "../../assets/icons/refresh.svg";
import PlusIcon from "../../assets/icons/plus-white.svg";
import {IMG_HOST, BACKEND_API_HOST} from "../../helper/host";
import {TourContext} from "../guideComponent/guideTourProvicer";
import {withTourGuide} from "../guideComponent/withTourGuide";

export class TaskList extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            importLoading: false,
            karyawan: [],
            fileDoc: [],
            data: [],
            idDel: '',
            filter_title: '',
            task_id: "",
            task_title: "",
            task_desc: "",
            task_deadline: "",
            task_karyawan: [],
            task_daily: false,
            task_document: null,
            tugas_admin_document: null,
            pageCount: 0,
            currentPage: 0,
            totalData: 0,
            perPage: 0,
            paging: 20,
            modalAdd: false,
            modalImport: false,
            importFile: null,
            modalDetail: false,
            guide: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.resetFilter = this.resetFilter.bind(this)
        this.wantDelete = this.wantDelete.bind(this)
        this.importExcel = this.importExcel.bind(this)
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    disableBody = target => disableBodyScroll(target)
    enableBody = target => enableBodyScroll(target)

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handlePageClick(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadData();
        });
    }

    onEditorStateChange(evt) {
        var newContent = evt.editor.getData();
        this.setState({
            task_desc: newContent
        })
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    handleOk = e => {
        if(!this.state.loading) {
            this.setState({
                modalAdd: false,
                modalDetail: false,
                modalImport: false,
            });
        }
    };

    handleCancel = e => {
        if(!this.state.loading) {
            this.setState({
                modalAdd: false,
                modalDetail: false,
                modalImport: false,
            });
        }
    };

    resetFilter(event) {
        this.setState({
            filter_title: '',
            loading: true
        }, () => this.loadData())
    }

    moveTaskItem = (dragIndex, hoverIndex) => {
        const item = this.state.data[dragIndex];
        const newItems = this.state.data.filter((i, idx) => idx !== dragIndex);
        newItems.splice(hoverIndex, 0, item);
        this.setState({
            data: newItems
        })
    }

    dropTaskItem = (item, monitor, status) => {
        const newItems = this.state.data
            .filter((i) => i.task_id !== item.item.task_id)
            .concat({ ...item.item, task_status: status });
        this.changeCardStatus(item.item.task_id, status)
        this.setState({
            data: newItems
        })
    }

    wantDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus Tugas ini?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        id: this.state.task_id
                    }
                    this.setState({
                        modalDetail: false,
                        data: [],
                        loading: true
                    })
                    this.props.request("task/delete", form, 'POST')
                        .then(response => {
                            if (response && response.success) {
                                toast.success(response.message)
                                this.loadData()
                            }
                        });
                }
            })
    }

    changeCardStatus(id, status) {
        toast.dismiss()
        toast.info('Menyimpan...', {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
        let form = {
            id: id,
            status: status
        }

        this.props.request("task/change-status", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    toast.dismiss()
                }
            });
    }

    createTask() {
        this.setState({
            loading: true
        })
        let form = {
            title: this.state.task_title,
            desc: this.state.task_desc,
            deadline: this.state.task_deadline,
            karyawan: this.state.task_karyawan,
            daily: this.state.task_daily ? "1" : "0",
            document: this.state.task_document,
        }
        this.props.request("task/add", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.loadData()
                    this.setState({
                        modalAdd: false,
                        task_title: "",
                        task_desc: "",
                        task_deadline: "",
                        task_karyawan: [],
                        task_document: null,
                        loading: false
                    })
                }
            });
    }

    updateTask() {
        this.setState({
            loading: true
        })
        let form = {
            id: this.state.task_id,
            title: this.state.task_title,
            desc: this.state.task_desc,
            deadline: this.state.task_deadline,
            karyawan: this.state.task_karyawan,
            daily: this.state.task_daily ? "1" : "0",
            document: this.state.task_document,
        };
        this.props.request("task/update", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data,
                        loading: false,
                    })
                }
            });
    }

    openTaskDetail(item){
        this.setState({
            modalDetail: true,
            task_id: item.task_id,
            task_title: item.task_title,
            task_desc: item.task_desc,
            task_deadline: item.task_deadline,
            task_daily: item.task_daily == '1' ? true : false,
            task_document: item.tugas_admin_document,
            task_karyawan: item.karyawan ? item.karyawan.map(function (item) {
                return parseInt(item.karyawan_id);
            }) : null,

        })
        if (item.tugas_admin_document !== null){
            this.setState({
                fileDoc: [
                    {
                        uid: '-1',
                        name: item.tugas_admin_document,
                        status: 'done',
                        url: IMG_HOST + 'frontapp/tugas/document/' + item.tugas_admin_document
                    }

                ],
            })
        } else {
            this.setState({
                fileDoc : []
            })
        }
    }

    searchKaryawan(value){
        let form = {
            karyawan_name : value
        }
        this.props.request("karyawan/search-karyawan", form, "POST")
            .then((response)=> {
                if (response && response.success){
                    this.setState({
                        karyawan: response.data,
                        karyawan_loading: false
                    })
                }
            })
    }

    loadKaryawan(){
        let form = {}
        this.props.request("karyawan/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        karyawan: response.data,
                        loading         : false
                    })
                }
            });
    }

    loadData() {
        let form = {
            title: this.state.filter_title
        }
        this.props.request("task/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data,
                        loading: false
                    })
                }
            });
    }

    exportTask = () => {
        var AuthKey = localStorage.getItem('Presensi-Auth-Key')
        window.open(BACKEND_API_HOST + 'task/export_template?token=' + AuthKey, "_blank")
    }

    importExcel = () => {
        this.setState({
            importLoading: true
        })

        var AuthKey = localStorage.getItem('Presensi-Auth-Key')

        let formData = new FormData()
        formData.append('file', this.state.importFile)
        formData.append('token', AuthKey)

        fetch(BACKEND_API_HOST + 'task/import', {
            method: 'POST',
            headers: {
                'Authorization': 'bearer ' + AuthKey
            },
            body: formData
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error(error);
            })
            .then((response) => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                    window.location.reload();
                    this.setState({
                        modalimport: false,
                        loading: true,
                        importFile: null,
                        data: [],
                    }, () => {
                        this.loadData()
                    })
                }
                else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        showConfirmButton: false,
                        timer: 1200,
                    })
                    this.setState({
                        modalimport: false,
                    })
                }

                this.setState({ importLoading: false })
            })
    }

    componentDidMount() {
        this.loadData()
        this.loadKaryawan()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.pengumuman-filter-nama-input',
                        title: 'Cari Tugas',
                        content: 'Gunakan kolom pencarian ini untuk mencari tugas berdasarkan judul. Tekan Enter untuk memulai pencarian.'
                    },
                    {
                        selector: '.pengumuman-button-refresh',
                        title: 'Reset Filter',
                        content: 'Klik tombol ini untuk mengembalikan filter ke pengaturan awal dan memuat ulang data tugas.'
                    },
                    {
                        selector: '.pengumuman-add-button.mr-md-2',
                        title: 'Import Tugas',
                        content: 'Klik tombol ini untuk mengimpor data tugas secara massal melalui file.'
                    }
                ];

                if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) {
                    tourSteps.push({
                        selector: '.pengumuman-add-button',
                        title: 'Tambah Tugas',
                        content: 'Klik tombol ini untuk menambahkan data tugas baru.'
                    });
                }

                const draftCount = this.state.data.filter(i => i.task_status === "draft").length;
                const inprogressCount = this.state.data.filter(i => i.task_status === "inprogress").length;
                const finishedCount = this.state.data.filter(i => i.task_status === "finished").length;

                tourSteps.push(
                    {
                        selector: '.col-wrapper:nth-child(1)',
                        title: 'Kolom Draft',
                        content: `Kolom ini menampilkan ${draftCount} tugas yang masih berstatus Draft. Seret kartu tugas ke kolom lain untuk mengubah statusnya.`
                    },
                    {
                        selector: '.col-wrapper:nth-child(2)',
                        title: 'Kolom Sedang Dikerjakan',
                        content: `Kolom ini menampilkan ${inprogressCount} tugas yang sedang dalam pengerjaan. Klik kartu tugas untuk melihat detailnya.`
                    },
                    {
                        selector: '.col-wrapper:nth-child(3)',
                        title: 'Kolom Selesai Dikerjakan',
                        content: `Kolom ini menampilkan ${finishedCount} tugas yang sudah selesai dikerjakan.`
                    }
                );

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        const { Option } = Select;
        const steps = [
            {
                selector: '.tambah',
                content: 'Anda dapat membuat Pengumuman disini',
            },
            {
                selector: '.daftar-tugas',
                content: 'Daftar Pengumuman anda dapat dilihat disini',
            },
        ];
        if (this.props.user && this.props.user.perusahaan.langganan && this.props.user.perusahaan.langganan.paket.paket_premium == "1") {
                return (
                    <Fragment>
                        <Helmet>
                            <meta charSet="utf-8" />
                            <title>Daftar Tugas - Presensi</title>
                            <meta name="description" content="Daftar Tugas" />
                        </Helmet>
                        <Breadcrumb title="Daftar Tugas" parent="Tugas" setGuide={() => {
                            this.setState({ guide: true })
                        }} />
                        <Tour steps={steps} isOpen={this.state.guide === true} onAfterOpen={this.disableBody}
                              onBeforeClose={this.enableBody} onRequestClose={() => this.setState({ guide: false })} />
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header border-0 p-4">
                                    <div className='row'>
                                        <div className='col-md-6 pengumuman-col-filter'>
                                            <div className='d-flex flex-row flex-nowrap'>
                                                <div className='input-group mr-1 btn-search-tugas'>
                                                <span className='input-group-text pengumuman-filter-nama-input-text'>
                                                    <img alt='' src={SearchIcon} />
                                                </span>
                                                    <input name="filter_title"
                                                           className="form-control pengumuman-filter-nama-input"
                                                           placeholder="Cari Tugas..."
                                                           type="text"
                                                           required=""
                                                           value={this.state.filter_title}
                                                           style={{ display: "inline-block", boxSizing: 'border-box' }}
                                                           onChange={this.handleChange}
                                                           onKeyUp={(event) => {
                                                               if (event.which == 13) {
                                                                   event.preventDefault()
                                                                   this.setState({
                                                                       page: 0,
                                                                       paging: this.state.paging,
                                                                       loading: true
                                                                   }, () => {
                                                                       this.loadData()
                                                                   });
                                                               }
                                                           }} />
                                                </div>
                                                <button className='pengumuman-button-refresh' onClick={this.resetFilter}>
                                                    <img alt='' src={RefreshIcon} />
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) && (
                                                <button className='pengumuman-add-button mb-2' onClick={() => this.setState({
                                                    modalAdd: true
                                                })}><img alt='' src={PlusIcon}/> Tambah</button>
                                            )}
                                            <button className='pengumuman-add-button mr-md-2' style={{padding: "11px"}}
                                                    onClick={() => this.setState({
                                                        modalImport: true
                                                    })}>Import Tugas
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body daftar-pengumuman">
                                    <div className="row">
                                        <div className="col-wrapper col-md-4 mb-3">
                                            <div style={{
                                                padding: 16,
                                                borderStyle: 'solid',
                                                borderWidth: 1,
                                                borderRadius: '12px 12px 0px 0px',
                                                backgroundColor: '#E8F4FF',
                                                borderColor: '#fff',
                                            }}>
                                                <h4 style={{ fontSize: 'medium', fontWeight: 'bold', margin: '0' }} className="text-left">
                                                    Draft
                                                </h4>
                                            </div>
                                            {this.state.data.filter((i) => i.task_status === "draft").length > 0 ?
                                                <DropWrapper onDrop={this.dropTaskItem} status={"draft"}>
                                                    <div style={{
                                                        padding: 16,
                                                        borderStyle: 'solid',
                                                        borderWidth: 1,
                                                        borderRadius: '0px 0px 12px 12px',
                                                        backgroundColor: '#E8F4FF',
                                                        borderColor: '#fff',
                                                    }}>
                                                        {this.state.data
                                                            .filter((i) => i.task_status === "draft")
                                                            .map((item, index) => (
                                                                <div key={item.task_id} onClick={() => {this.openTaskDetail(item)}}>
                                                                    <TaskItem
                                                                        key={item.task_id}
                                                                        item={item}
                                                                        index={index}
                                                                        moveItem={this.moveTaskItem}
                                                                        status={"draft"}
                                                                    />
                                                                </div>
                                                            ))}
                                                    </div>
                                                </DropWrapper>
                                                :
                                                <DropWrapper onDrop={this.dropTaskItem} status={"draft"}>
                                                    <div className="p-3">
                                                        <div className="media static-top-widget">
                                                            <div className="media-body">
                                                                <p className={'item-title text-center'}>Data Kosong</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </DropWrapper>
                                            }
                                        </div>

                                        <div className="col-wrapper col-md-4 mb-3">
                                            <div style={{
                                                padding: 16,
                                                borderStyle: 'solid',
                                                borderWidth: 1,
                                                borderRadius: '12px 12px 0px 0px',
                                                backgroundColor: '#E8F4FF',
                                                borderColor: '#fff',
                                            }}>
                                                <h4 style={{ fontSize: 'medium', fontWeight: 'bold', margin: '0' }} className="text-left">
                                                    Sedang Dikerjakan
                                                </h4>
                                            </div>
                                            {this.state.data.filter((i) => i.task_status === "inprogress").length > 0 ?
                                                <DropWrapper onDrop={this.dropTaskItem} status={"inprogress"}>
                                                    <div style={{
                                                        padding: 16,
                                                        borderStyle: 'solid',
                                                        borderWidth: 1,
                                                        borderRadius: '0px 0px 12px 12px',
                                                        backgroundColor: '#E8F4FF',
                                                        borderColor: '#fff',
                                                    }}>
                                                        {this.state.data
                                                            .filter((i) => i.task_status === "inprogress")
                                                            .map((item, index) => (
                                                                <div onClick={() => {this.openTaskDetail(item)}}>
                                                                    <TaskItem
                                                                        key={item.task_id}
                                                                        item={item}
                                                                        index={index}
                                                                        moveItem={this.moveTaskItem}
                                                                        status={"inprogress"}
                                                                    />
                                                                </div>
                                                            ))}
                                                    </div>
                                                </DropWrapper>
                                                :
                                                <DropWrapper onDrop={this.dropTaskItem} status={"inprogress"}>
                                                    <div className="p-3">
                                                        <div className="media static-top-widget">
                                                            <div className="media-body">
                                                                <p className={'item-title text-center'}>Data Kosong</p></div>
                                                        </div>
                                                    </div>
                                                </DropWrapper>
                                            }
                                        </div>
                                        <div className="col-wrapper col-md-4">
                                            <div style={{
                                                padding: 16,
                                                borderStyle: 'solid',
                                                borderWidth: 1,
                                                borderRadius: '12px 12px 0px 0px',
                                                backgroundColor: '#E8F4FF',
                                                borderColor: '#fff',
                                            }}>
                                                <h4 style={{ fontSize: 'medium', fontWeight: 'bold', margin: '0' }} className="text-left">
                                                    Selesai Dikerjakan
                                                </h4>
                                            </div>
                                            {this.state.data.filter((i) => i.task_status === "finished").length > 0 ?
                                                <DropWrapper onDrop={this.dropTaskItem} status={"finished"}>
                                                    <div style={{
                                                        padding: 16,
                                                        borderStyle: 'solid',
                                                        borderWidth: 1,
                                                        borderRadius: '0px 0px 12px 12px',
                                                        backgroundColor: '#E8F4FF',
                                                        borderColor: '#fff',
                                                    }}>
                                                        {this.state.data
                                                            .filter((i) => i.task_status === "finished")
                                                            .map((item, index) => (
                                                                <div onClick={() => {this.openTaskDetail(item)}}>
                                                                    <TaskItem
                                                                        key={item.task_id}
                                                                        item={item}
                                                                        index={index}
                                                                        moveItem={this.moveTaskItem}
                                                                        status={"finished"}
                                                                    />
                                                                </div>
                                                            ))}
                                                    </div>
                                                </DropWrapper>
                                                :
                                                <DropWrapper onDrop={this.dropTaskItem} status={"finished"}>
                                                    <div className="p-3">
                                                        <div className="media static-top-widget">
                                                            <div className="media-body">
                                                                <p className={'item-title text-center'}>Data Kosong</p></div>
                                                        </div>
                                                    </div>
                                                </DropWrapper>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Modal
                                title="Tugas Baru"
                                visible={this.state.modalAdd}
                                onOk={this.handleOk}
                                onCancel={()=> this.setState({
                                    modalAdd        : false,
                                    task_id         : "",
                                    task_title      : "",
                                    task_desc       : "",
                                    task_deadline   : "",
                                    task_karyawan   : [],
                                    task_document   : null,
                                    task_daily      : false,
                                    fileDoc         : []
                                })}
                                footer={[
                                    this.state.loading ?
                                        <button className={'btn btn-primary'} style={{ textTransform: "none" }} disabled={true}><i className="fa fa-refresh fa-spin"></i>  Menyimpan data</button>
                                        :
                                        <>
                                            <button className={'btn btn-primary'} style={{ textTransform: "none" }} onClick={() => {this.createTask()}}>Simpan</button>
                                        </>
                                ]}
                            >
                                <div>
                                    <div className="mb-2 row" style={{margin: 0}}>
                                        <div className="col-auto p-0"
                                             onPointerEnter={(e) => {
                                                 this.triggerGuideOnce(e, {
                                                     key: "tugasHarian",
                                                     title: "Tugas Harian",
                                                     content: "Centang opsi ini jika tugas akan muncul setiap hari pada aplikasi karyawan."
                                                 });
                                             }}
                                        >
                                            <Checkbox
                                                onChange={(val) => {
                                                    this.setState({
                                                        task_daily: val.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <div>Tugas Harian<small className="text-muted">(Tugas akan muncul setiap hari pada App Karyawan)</small></div>
                                        </div>
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Judul Tugas</span>
                                    <div className="mt-1 mb-2">
                                        <input name="task_title"
                                               className="form-control smaller-placeholder"
                                               placeholder="Ketik judul tugas disini"
                                               type="text" required="" value={this.state.task_title}
                                               onChange={this.handleChange}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "judulTugas",
                                                       title: "Judul Tugas",
                                                       content: "Isi kolom ini dengan judul tugas yang ingin ditambahkan."
                                                   });
                                               }}
                                        />
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Deadline</span>
                                    <div className="row align-items-center mt-1 mb-1" style={{margin: "auto"}}>
                                        <input name="task_deadline"
                                               value={this.state.task_deadline == null ? "0000-00-00" : this.state.task_deadline}
                                               className="form-control col-xl-8 col-md-7"
                                               onChange={this.handleChange}
                                               type="date" required=""
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "deadlineTugas",
                                                       title: "Deadline",
                                                       content: "Pilih tanggal batas waktu penyelesaian tugas."
                                                   });
                                               }}
                                        />
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Karyawan</span>
                                    <div className="row align-items-center mt-1 mb-2" style={{margin: "auto"}}
                                         onPointerEnter={(e) => {
                                             this.triggerGuideOnce(e, {
                                                 key: "karyawanTugas",
                                                 title: "Karyawan",
                                                 content: "Pilih satu atau lebih karyawan yang akan diberikan tugas ini. Kosongkan jika tugas ditujukan untuk semua karyawan."
                                             });
                                         }}
                                    >
                                        <Select name="task_karyawan"
                                                className={"col"}
                                                mode={"multiple"}
                                                placeholder="Pilih Karyawan (Kosongkan Untuk Semua Karyawan)"
                                                value={this.state.task_karyawan}
                                                onSearch={(value) => this.searchKaryawan(value)}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={(event) => {
                                                    this.setState({
                                                        task_karyawan: event
                                                    })
                                                }}>
                                            {this.state.karyawan.map((item, index) => {
                                                return (<Option value={item.karyawan_id} key={item.karyawan_id}>{item.karyawan_nama}</Option>)
                                            })}
                                        </Select>
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>
                                        Dokumen
                                    </span>
                                    <div style={{
                                        position: 'relative',
                                        width: '100%',
                                        backgroundColor: '#F9F9F9',
                                        padding: 6,
                                        borderRadius: 4,
                                        marginTop: 8,
                                        border: "1px dashed #DDDDDD"
                                    }} className="mb-4">
                                        <Upload
                                            customRequest={({file, onSuccess}) => {
                                                setTimeout(() => {
                                                    onSuccess("ok");
                                                }, 0);
                                            }}
                                            accept=".docx, .doc, .pdf"
                                            fileList={this.state.fileDoc}
                                            onRemove={() => {
                                                this.setState({task_document: null});
                                            }}
                                            onChange={({file, fileList}) => {
                                                this.setState({fileDoc: fileList});
                                                if (fileList.length > 0) {
                                                    let files = file.originFileObj;
                                                    let reader = new FileReader();
                                                    reader.readAsDataURL(files);
                                                    reader.onloadend = () => {
                                                        this.setState({
                                                            task_document: {
                                                                name: file.name,
                                                                file: reader.result
                                                            }
                                                        });
                                                    };
                                                } else {
                                                    this.setState({task_document: null});
                                                }
                                            }}
                                        >
                                            {this.state.fileDoc.length >= 1 ? null :
                                                <div
                                                    onPointerEnter={(e) => {
                                                        this.triggerGuideOnce(e, {
                                                            key: "dokumenTugas",
                                                            title: "Dokumen",
                                                            content: "Upload dokumen pendukung tugas dalam format .docx, .doc, atau .pdf."
                                                        });
                                                    }}
                                                >
                                                    <a className="btn btn-outline-custom">Cari Dokumen</a>
                                                </div>
                                            }
                                        </Upload>
                                    </div>
                                    <div
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "deskripsiTugas",
                                                title: "Deskripsi Tugas",
                                                content: "Isi kolom ini dengan deskripsi atau instruksi lengkap mengenai tugas yang harus dikerjakan oleh karyawan."
                                            });
                                        }}
                                    >
                                        <CKEditor
                                            content={this.state.task_desc}
                                            events={{
                                                change: this.onEditorStateChange
                                            }}
                                            config={{versionCheck: false}}
                                        />
                                    </div>
                                </div>
                            </Modal>
                            <Modal
                                title="Detail Tugas"
                                visible={this.state.modalDetail}
                                onOk={this.handleOk}
                                onCancel={this.handleCancel}
                                footer={[
                                    this.state.loading ?
                                        <button className={'btn btn-primary'} style={{ textTransform: "none" }} disabled={true}><i className="fa fa-refresh fa-spin"></i>  Menyimpan data</button>
                                        :
                                        <>
                                        {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0) && (
                                            <button className={'btn btn-danger mr-3'} style={{ textTransform: "none" }} onClick={() => {this.wantDelete()}}>Hapus</button>
                                        )}
                                            <button className={'btn btn-primary'} style={{ textTransform: "none" }} onClick={() => {this.updateTask()}}>Simpan</button>
                                        </>
                                ]}>
                                <div>
                                    <div className="mb-2 row" style={{margin: 0}}>
                                        <div className="col-auto p-0"
                                             onPointerEnter={(e) => {
                                                 this.triggerGuideOnce(e, {
                                                     key: "tugasHarianEdit",
                                                     title: "Tugas Harian",
                                                     content: "Centang opsi ini jika tugas akan muncul setiap hari pada aplikasi karyawan."
                                                 });
                                             }}
                                        >
                                            <Checkbox
                                                checked={this.state.task_daily}
                                                onChange={(val) => {
                                                    this.setState({
                                                        task_daily: val.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <div>Tugas Harian<small className="text-muted">(Tugas akan muncul setiap
                                                hari pada App Karyawan)</small></div>
                                        </div>
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Judul Tugas</span>
                                    <div className="mt-1 mb-2">
                                        <input name="task_title" className="form-control" placeholder="Judul Tugas"
                                               type="text" required="" value={this.state.task_title}
                                               onChange={this.handleChange}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "judulTugasEdit",
                                                       title: "Judul Tugas",
                                                       content: "Ubah kolom ini untuk memperbarui judul tugas."
                                                   });
                                               }}
                                        />
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Deadline</span>
                                    <div className="row align-items-center mt-2 mb-2" style={{margin: "auto"}}>
                                        <input name="task_deadline"
                                               value={this.state.task_deadline == null ? "0000-00-00" : this.state.task_deadline}
                                               className="form-control col-xl-8 col-md-7"
                                               onChange={this.handleChange}
                                               type="date" required=""
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "deadlineTugasEdit",
                                                       title: "Deadline",
                                                       content: "Ubah tanggal batas waktu penyelesaian tugas jika diperlukan."
                                                   });
                                               }}
                                        />
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>Karyawan</span>
                                    <div className="row align-items-center mt-1 mb-2" style={{margin: "auto"}}
                                         onPointerEnter={(e) => {
                                             this.triggerGuideOnce(e, {
                                                 key: "karyawanTugasEdit",
                                                 title: "Karyawan",
                                                 content: "Ubah atau tambahkan karyawan yang ditugaskan. Kosongkan jika tugas ditujukan untuk semua karyawan."
                                             });
                                         }}
                                    >
                                        <Select name="task_karyawan"
                                                className={"col"}
                                                mode={"multiple"}
                                                placeholder="Pilih Karyawan (Kosongkan Untuk Semua Karyawan)"
                                                value={this.state.task_karyawan}
                                                onSearch={(value) => this.searchKaryawan(value)}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={(event) => {
                                                    this.setState({
                                                        task_karyawan: event
                                                    })
                                                }}>
                                            {this.state.karyawan.map((item, index) => {
                                                return (<Option value={item.karyawan_id} key={item.karyawan_id}>{item.karyawan_nama}</Option>)
                                            })}
                                        </Select>
                                    </div>
                                    <span className="mr-2" style={{fontWeight: 'bold', fontSize: 'smaller'}}>
        Dokumen
    </span>
                                    <div style={{
                                        position: 'relative',
                                        width: '100%',
                                        backgroundColor: '#F9F9F9',
                                        padding: 6,
                                        borderRadius: 4,
                                        marginTop: 8,
                                        border: "1px dashed #DDDDDD"
                                    }} className="mb-4">
                                        <Upload
                                            customRequest={({file, onSuccess}) => {
                                                setTimeout(() => {
                                                    onSuccess("ok");
                                                }, 0);
                                            }}
                                            accept=".docx, .doc, .pdf"
                                            fileList={this.state.fileDoc}
                                            onRemove={() => {
                                                this.setState({task_document: null});
                                            }}
                                            onChange={({file, fileList}) => {
                                                this.setState({fileDoc: fileList});
                                                if (fileList.length > 0) {
                                                    let files = file.originFileObj;
                                                    let reader = new FileReader();
                                                    reader.readAsDataURL(files);
                                                    reader.onloadend = () => {
                                                        this.setState({
                                                            task_document: {
                                                                name: file.name,
                                                                file: reader.result
                                                            }
                                                        });
                                                    };
                                                } else {
                                                    this.setState({task_document: null});
                                                }
                                            }}
                                        >
                                            {this.state.fileDoc.length >= 1 ? null :
                                                <div
                                                    onPointerEnter={(e) => {
                                                        this.triggerGuideOnce(e, {
                                                            key: "dokumenTugasEdit",
                                                            title: "Dokumen",
                                                            content: "Upload atau ganti dokumen pendukung tugas dalam format .docx, .doc, atau .pdf."
                                                        });
                                                    }}
                                                >
                                                    <a className="btn btn-outline-custom">Cari Dokumen</a>
                                                </div>
                                            }
                                        </Upload>
                                    </div>
                                    <div
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "deskripsiTugasEdit",
                                                title: "Deskripsi Tugas",
                                                content: "Ubah deskripsi atau instruksi tugas yang harus dikerjakan oleh karyawan."
                                            });
                                        }}
                                    >
                                        <CKEditor
                                            content={this.state.task_desc}
                                            events={{
                                                change: this.onEditorStateChange
                                            }}
                                            config={{versionCheck: false}}
                                        />
                                    </div>
                                </div>
                            </Modal>
                            <Modal title="Import Tugas" visible={this.state.modalImport} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
                                this.state.importLoading ?
                                    <button className={'btn btn-primary'} style={{ textTransform: "none", width: "100%" }} disabled={true}><i className="fa fa-refresh fa-spin"></i>  Sedang mengupload data</button>
                                    :
                                    <button className={this.state.importFile === null ? 'btn bg-secondary-custom' : 'btn btn-primary'} style={{ textTransform: "none", width: "100%" }} disabled={this.state.importFile === null} onClick={this.importExcel}>Import Data</button>
                            ]}>
                                <div>
                                    <div>
                                        <a>Anda bisa mengunduh template yang sudah kami sediakan untuk mempermudah
                                            pengimportan.</a><br/>
                                        <a style={{color: "#057CE4"}} onClick={this.exportTask}>Unduh Template</a>
                                    </div>
                                    <div style={{
                                        position: 'relative',
                                        width: '100%',
                                        backgroundColor: '#F9F9F9',
                                        padding: 16,
                                        borderRadius: 6,
                                        marginTop: 8,
                                        border: "1px dashed #DDDDDD"
                                    }}>
                                        <input type='file'
                                               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                               onChange={(event) => {
                                                   this.setState({
                                                       importFile: event.target.files[0],
                                                   })
                                               }}/><br/>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </Fragment>
                )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Fitur ini hanya tersedia untuk Paket Premium+.</h5>
                    <h5 className="text-center pt-4"><a href="/langganan">Upgrade ke Premium+.</a></h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(withTourGuide(TaskList), PERMISSIONS.TUGAS));
